import { useLingui } from '@lingui/react';
import { useLocation } from 'react-router-dom';
import { ButtonLinkWithIcon } from '../../Atoms/Buttons';
import PdfPreview from '../../Molecules/Document/PdfPreview';

const EmailDocumentAttachment = ({ eventId, attachment, deleteAtIndex, index }) => {
  const { i18n } = useLingui();
  const { pathname } = useLocation();

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'baseline',
      border: '1px solid rgba(0, 0, 0, .125)',
      borderRadius: 4,
      marginRight: 5,
      marginBottom: 5,
      padding: 5,
      backgroundColor: '#ffffff',
    },
    documentType: {
      display: 'flex',
      flex: 1,
    },
    fileName: {
      display: 'flex',
      flex: 1,
    },
    templateSelect: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'flex',
      alignItems: 'center',
    },
    actions: {
      display: 'flex',
    },
    action: {
      paddingLeft: 5,
      paddingRight: 5,
    },
  };

  return (
    <div style={styles.container}>
      {!pathname.includes('emails') && (
        <div style={styles.documentType}>{i18n._(`document.${attachment.documentType.toLowerCase()}`)}</div>
      )}

      <div style={styles.fileName}>{attachment.fileName}</div>

      {!pathname.includes('emails') && (
        <div style={styles.templateSelect}>
          {attachment.templateName && <div>Vorlage: {attachment.templateName}</div>}
        </div>
      )}

      <div style={styles.actions}>
        <PdfPreview file={attachment} eventId={eventId} lastModified={() => {}} button={ButtonLinkWithIcon} />
        {deleteAtIndex && (
          <ButtonLinkWithIcon style={styles.action} icon="TRASH" onClick={() => deleteAtIndex(index)} title="" />
        )}
      </div>
    </div>
  );
};

export default EmailDocumentAttachment;
